<div class="registration">

  <h3>
    <div class="row">
      <div class="col-8">
    <a [routerLink]="[registration.encId]">
      <span *ngIf="registration.shortDescription?.pl">{{registration.shortDescription.pl}}<br/></span>
      <span *ngIf="!registration.shortDescription?.pl">{{registration.id}}<br/></span>
      <ng-container *ngIf="registration.description.pl">{{registration.description}}</ng-container> [{{registration.id}}]
    </a>
      </div>
      <div class="col-4">
        <img *ngIf="registration.isLinkMandatory" i18n-matTooltip
             matTooltip="Student rejestrując się na zajęcia musi zadeklarować, pod jaki program chce go podpiąć"
             src="img/spinacz_tip.png">
        <img *ngIf="registration.registrationType == 'Direct'" i18n-matTooltip
             matTooltip="Rejestracja w trybie bezpośrednim"
             src="img/rejestracja_bezposrednia.png">

        <img *ngIf="registration.registrationType == 'MicroRound'" i18n-matTooltip
             matTooltip="Rejestracja w trybie mikrotur"
             src="img/rejestracja_mikroturowa.png">
      </div>
    </div>
    <div *ngIf="registration.message?.pl" class="note">
      {{registration.message}}
    </div>
  </h3>
  <app-rounds [registration]="registration"></app-rounds>
  <p>
    <a *ngIf="registration.isOpen()" [href]="registration.getUsoswebUrl()" class="go-forward" i18n>Przejdź, aby się
      zarejestrować na zajęcia</a>
  </p>
</div>
